import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=352f188b"
import script from "./sidebar.js?vue&type=script&lang=js&external"
export * from "./sidebar.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports